import i18n from "./index";

const loadedNamespaces = new Set<string>();

export async function loadNamespace({ lng, ns }: { lng: string; ns: string }) {
  const cacheKey = `${lng}:${ns}`;
  if (loadedNamespaces.has(cacheKey) || i18n.hasResourceBundle(lng, ns)) {
    loadedNamespaces.add(cacheKey);
    return;
  }
  // translations API not available — use empty bundle
  i18n.addResourceBundle(lng, ns, {}, true, true);
  loadedNamespaces.add(cacheKey);
}

export async function ensureReady({
  lng,
  nsList,
}: {
  lng: string;
  nsList: string[];
}) {
  await Promise.all(nsList.map(ns => loadNamespace({ lng, ns })));
}
